<template>
<div>
    <!-- 后台返回错误信息 -->
    <!-- <form-error-msg :error='error'></form-error-msg> -->

    <div class="tgo-phone columns is-multify">
      <!-- 手机号表单 -->
      <input-phone ref="phone" class="tgo-phone-input column is-half" v-model="mobile" :selectCode="country" @setCountry='setCountry'></input-phone>
      <!-- 短信验证码表单 -->
      <input-captcha ref="captcha" class="tgo-phone-captcha column is-half" v-model="captcha" :mobile='mobile' :country='country' :img-captcha='imgCaptcha' request-url="/serv/tgo/common/cellphone" v-if="$store.state.isLogin!==true" @error='handleCaptchaError' @showImgCaptcha="showImgCaptchaBox"></input-captcha>
    </div>

    <!-- 图片验证码 -->
    <img-captcha :show='isImgCaptchaShow' :error-msg='imgCaptchaError' request-url='/serv/tgo/common/captcha' @cancel='cancelImgCaptcha' @captcha='imgCaptchaHandler'></img-captcha>
  </div>
</template>
<script>
import InputPhone from './components/form/Phone'
import InputCaptcha from './components/form/Captcha'
import ImgCaptcha from './components/form/ImgCaptcha'
// import UserService from './service/user'
import validateMethods from './utils/validate'
// import utils from './utils/index'

export default {
  components: {
    InputPhone,
    InputCaptcha,
    ImgCaptcha
  },
  data () {
    return {
      country: this.areaCode || 86,
      mobile: this.phone || '',
      captcha: '', // 短信验证码
      imgCaptcha: '', // 图形验证码
      isImgCaptchaShow: false,
      error: '', // 后台错误信息
      imgCaptchaError: '',
      submitDisable: false,
      redirect: null // 保存跳转信息
      // phonePass: false // 手机是否通过
    }
  },
  props: ['phone', 'areaCode'],
  computed: {
    // country: {
    //   get: function () {
    //     return this.areaCode || this.countryShadow
    //   },
    //   set: function (data) {
    //     this.countryShadow = data
    //     this.$emit('input', { key: 'area_code', value: `+${data}` })
    //   }
    // },
    // mobile: {
    //   get: function () {
    //     return this.phone || this.mobileShadow
    //   },
    //   set: function (data) {
    //     this.mobileShadow = data
    //     this.$emit('input', { key: 'phone', value: data })
    //   }
    // }
  },
  watch: {
    // 后台返回的错误3秒后自动消失
    error (newVal) {
      clearInterval(this.clearErrorMsg)
      this.clearErrorMsg = setTimeout(() => {
        this.error = ''
      }, 2500)
    }
  },
  created () {
  },
  methods: {
    setCountry (country) {
      this.country = country
    },
    cancelImgCaptcha () {
      this.isImgCaptchaShow = false
    },
    imgCaptchaHandler (captcha) {
      this.imgCaptcha = captcha
      this.isImgCaptchaShow = false
    },
    showImgCaptchaBox () {
      this.imgCaptcha = ''
      this.isImgCaptchaShow = true
    },
    handleCaptchaError (err) {
      if (err.type === 'main') {
        this.error = err.msg
      } else {
        this.imgCaptchaError = err.msg
      }
    },
    // getphoneState (v) {
    //   this.phonePass = v
    // },
    // submit () {
    //   this.submitDisable = true
    //   let {country, mobile, captcha} = this
    //   if (this.checkPhone() && this.checkCaptcha()) {
    //     let ucode = this.$route.query.gk_ucode ? this.$route.query.gk_ucode : ''
    //     UserService.smslogin(country, mobile, captcha, ucode).then(user => {
    //       console.log(user)
    //       this.setLoginUser(user)
    //       this.submitDisable = false
    //       let redirect = this.redirect
    //       if (redirect) {
    //         window.location.href = redirect
    //       } else if (window.opener) {
    //         try {
    //           window.opener.location.reload()
    //           window.close()
    //         } catch (err) {
    //           if (user.type === 'register') {
    //             this.$router.push('/initpwd')
    //           } else {
    //             this.$router.push('/dashboard')
    //           }
    //         }
    //       } else {
    //         if (user.type === 'register') {
    //           this.$router.push('/initpwd')
    //         } else {
    //           this.$router.push('/dashboard')
    //         }
    //       }
    //     }).catch(err => {
    //       this.error = utils.parseError(err)
    //       this.submitDisable = false
    //     })
    //   } else {
    //     // this.errorMsg = '请核对表单内容'
    //     this.submitDisable = false
    //   }
    // },
    checkPhone () {
      if (!validateMethods.checkEmpty(this.mobile)) {
        this.error = '请输入手机号'
        return false
      }
      if (!validateMethods.checkMobile(this.mobile, this.country)) {
        this.error = '手机号格式错误'
        return false
      }
      return true
    },
    checkCaptcha () {
      if (!validateMethods.checkEmpty(this.captcha)) {
        this.error = '请输入短信验证码'
        return false
      }
      if (!validateMethods.checkCaptcha(this.captcha)) {
        this.error = '短信验证码格式错误'
        return false
      }
      return true
    },
    // public
    data () {
      return {
        area_code: `+${this.country}`,
        phone: this.mobile,
        code: this.captcha
      }
    },
    check () {
      let r = true
      r = this.$refs['phone'].check()
      // r = this.$refs['captcha'].check()
      if (this.$store.state.isLogin !== true) {
        r = this.$refs['captcha'].check()
      }
      return r
    }
  }
}
</script>
<style lang="sass" scoped>
@import '../../../style/bulma/app.sass'

.tgo-phone
  &:not(:last-child)
    margin-bottom: -0.75rem
</style>
